<template>
  <div
    class="w-0"
    :class="{
      'lg:w-14': isSidebarCollapsed,
      'lg:w-56': !isSidebarCollapsed,
    }">
    <Backdrop
      class="lg:hidden"
      :show="isMobileSidebarVisible"
      @click="() => closeMobileSidebar()" />
    <SideMenuCollapsed v-if="isSidebarCollapsed && !isMobileSidebarVisible" />
    <SideMenu v-else />
  </div>
</template>

<script setup lang="ts">
import {Backdrop} from '@myparcel-frontend/ui';
import {onKeyStroke} from '@vueuse/core';
import {watch} from 'vue';
import SideMenu from '@/components/ui/layout/sideMenu/SideMenu.vue';
import SideMenuCollapsed from '@/components/ui/layout/sideMenu/SideMenuCollapsed.vue';
import useBreakpoints from '@/composables/useBreakpoints';
import useSidebarToggle from '@/composables/useSidebarToggle';

const {isSidebarCollapsed, closeMobileSidebar, isMobileSidebarVisible} = useSidebarToggle();

const {greaterOrEqual} = useBreakpoints();

watch(greaterOrEqual('lg'), (value) => {
  if (value) {
    closeMobileSidebar();
  }
});

/* Close the mobile drawer on Escape, only when it is open. */
onKeyStroke('Escape', () => {
  if (isMobileSidebarVisible.value) {
    closeMobileSidebar();
  }
});
</script>
